const translations = {
    notes: 'Notes'
};

export default translations;
